module.exports = __webpack_public_path__ + "static/media/website-full.9739d129.png";